export default "__VITE_ASSET__Bn5StKu2__"